export const LOAD_INSIGHTS_PENDING = 'LOAD_INSIGHTS_PENDING'
export const GET_INSIGHTS_SUCCESSFUL = 'GET_INSIGHTS_SUCCESSFUL'
export const GET_INSIGHTS_ERROR = 'GET_INSIGHTS_ERROR'
export const CLEAR_INSIGHTS = 'CLEAR_INSIGHTS'
export const INSIGHTS_SEARCH_LIMIT = 500
export const LOAD_INSIGHTS_SUCCESSFUL = 'LOAD_INSIGHTS_SUCCESSFUL'
